var _style, _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataCenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    transform: "scale(1)",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    className: "show_show__wrapper__graphic__5Waiy ",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "React") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#474747;}\r\n\t.st2{fill:#D1D3D4;}\r\n\t.st3{fill:#db3236;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Server_back"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M126.7,152.7h92.8c2.5,0,4.5,2,4.5,4.5v134.9c0,2.5-2,4.5-4.5,4.5h-92.8c-2.5,0-4.5-2-4.5-4.5V157.2 C122.2,154.7,124.2,152.7,126.7,152.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M219.5,297.3h-92.8c-2.9,0-5.2-2.3-5.2-5.2V157.2c0-2.9,2.3-5.2,5.2-5.2h92.8c2.9,0,5.2,2.3,5.2,5.2v135 C224.6,295,222.3,297.3,219.5,297.3z M126.7,153.4c-2.1,0-3.8,1.7-3.8,3.8l0,0v135c0,2.1,1.7,3.8,3.8,3.8h92.8 c2.1,0,3.8-1.7,3.8-3.8v-135c0-2.1-1.7-3.8-3.8-3.8H126.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 131.3,
    y: 161.7,
    width: 83.6,
    height: 20.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M214.9,183h-83.6c-0.4,0-0.7-0.3-0.7-0.7v-20.6c0-0.4,0.3-0.7,0.7-0.7h83.6c0.4,0,0.7,0.3,0.7,0.7v20.6 C215.5,182.7,215.2,183,214.9,183z M132,181.6h82.2v-19.2H132V181.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 142.3,
    cy: 172,
    r: 4.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M207.2,169.5h-36.3c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h36.3c0.4,0,0.7,0.3,0.7,0.7 C207.9,169.2,207.6,169.5,207.2,169.5C207.2,169.5,207.2,169.5,207.2,169.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M207.2,175.9h-36.3c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h36.3c0.4,0,0.7,0.3,0.7,0.7 C207.9,175.6,207.6,175.9,207.2,175.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M163,176.6h-11.9c-0.4,0-0.7-0.3-0.7-0.7v-7.8c0-0.4,0.3-0.7,0.7-0.7H163c0.4,0,0.7,0.3,0.7,0.7v7.8 C163.7,176.3,163.4,176.6,163,176.6z M151.8,175.2h10.5v-6.4h-10.5L151.8,175.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 131.3,
    y: 186.6,
    width: 83.6,
    height: 20.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M214.9,207.9h-83.6c-0.4,0-0.7-0.3-0.7-0.7v-20.6c0-0.4,0.3-0.7,0.7-0.7h83.6c0.4,0,0.7,0.3,0.7,0.7v20.6 C215.6,207.6,215.2,207.9,214.9,207.9C214.9,207.9,214.9,207.9,214.9,207.9z M132,206.5h82.2v-19.2H132V206.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 142.3,
    cy: 196.9,
    r: 4.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M207.2,194.4h-36.3c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7c0,0,0,0,0,0h36.3c0.4,0,0.7,0.3,0.7,0.7 C207.9,194.1,207.6,194.4,207.2,194.4C207.2,194.4,207.2,194.4,207.2,194.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M207.2,200.8h-36.3c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7c0,0,0,0,0,0h36.3c0.4,0,0.7,0.3,0.7,0.7 C207.9,200.5,207.6,200.8,207.2,200.8C207.2,200.8,207.2,200.8,207.2,200.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M163,201.5h-11.9c-0.4,0-0.7-0.3-0.7-0.7V193c0-0.4,0.3-0.7,0.7-0.7H163c0.4,0,0.7,0.3,0.7,0.7v7.8 C163.7,201.2,163.4,201.5,163,201.5z M151.8,200.1h10.5v-6.4h-10.5L151.8,200.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 131.3,
    y: 211.5,
    width: 83.6,
    height: 20.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M214.9,232.8h-83.6c-0.4,0-0.7-0.3-0.7-0.7v-20.6c0-0.4,0.3-0.7,0.7-0.7h83.6c0.4,0,0.7,0.3,0.7,0.7v20.6 C215.6,232.5,215.2,232.8,214.9,232.8C214.9,232.8,214.9,232.8,214.9,232.8z M132,231.4h82.2v-19.2H132V231.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 142.3,
    cy: 221.8,
    r: 4.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M207.2,219.3h-36.3c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h36.3c0.4,0,0.7,0.3,0.7,0.7 C207.9,219,207.6,219.3,207.2,219.3C207.2,219.3,207.2,219.3,207.2,219.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M207.2,225.7h-36.3c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h36.3c0.4,0,0.7,0.3,0.7,0.7 C207.9,225.4,207.6,225.7,207.2,225.7C207.2,225.7,207.2,225.7,207.2,225.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M163,226.4h-11.9c-0.4,0-0.7-0.3-0.7-0.7v-7.8c0-0.4,0.3-0.7,0.7-0.7H163c0.4,0,0.7,0.3,0.7,0.7v7.8 C163.7,226.1,163.4,226.4,163,226.4z M151.8,225h10.5v-6.4h-10.5V225z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 131.3,
    y: 236.4,
    width: 83.6,
    height: 20.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M214.9,257.7h-83.6c-0.4,0-0.7-0.3-0.7-0.7l0,0v-20.6c0-0.4,0.3-0.7,0.7-0.7h83.6c0.4,0,0.7,0.3,0.7,0.7V257 C215.6,257.4,215.3,257.7,214.9,257.7C214.9,257.7,214.9,257.7,214.9,257.7z M132,256.3h82.2v-19.2H132V256.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 142.3,
    cy: 246.7,
    r: 4.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M207.2,244.2h-36.3c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h36.3c0.4,0,0.7,0.3,0.7,0.7 C207.9,243.9,207.6,244.2,207.2,244.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M207.2,250.6h-36.3c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h36.3c0.4,0,0.7,0.3,0.7,0.7 C207.9,250.3,207.6,250.6,207.2,250.6C207.2,250.6,207.2,250.6,207.2,250.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M163,251.3h-11.9c-0.4,0-0.7-0.3-0.7-0.7v-7.8c0-0.4,0.3-0.7,0.7-0.7H163c0.4,0,0.7,0.3,0.7,0.7v7.8 C163.7,251,163.4,251.3,163,251.3z M151.8,249.9h10.5v-6.4h-10.5L151.8,249.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 131.3,
    y: 261.3,
    width: 83.6,
    height: 20.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M214.9,282.6h-83.6c-0.4,0-0.7-0.3-0.7-0.7v-20.6c0-0.4,0.3-0.7,0.7-0.7h83.6c0.4,0,0.7,0.3,0.7,0.7l0,0v20.6 C215.6,282.3,215.2,282.6,214.9,282.6C214.9,282.6,214.9,282.6,214.9,282.6z M132,281.2h82.2V262H132V281.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 142.3,
    cy: 271.6,
    r: 4.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M207.2,269.1h-36.3c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7c0,0,0,0,0,0h36.3c0.4,0,0.7,0.3,0.7,0.7 C207.9,268.8,207.6,269.1,207.2,269.1C207.2,269.1,207.2,269.1,207.2,269.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M207.2,275.5h-36.3c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7c0,0,0,0,0,0h36.3c0.4,0,0.7,0.3,0.7,0.7 C207.9,275.2,207.6,275.5,207.2,275.5C207.2,275.5,207.2,275.5,207.2,275.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M163,276.2h-11.9c-0.4,0-0.7-0.3-0.7-0.7l0,0v-7.8c0-0.4,0.3-0.7,0.7-0.7c0,0,0,0,0,0H163 c0.4,0,0.7,0.3,0.7,0.7l0,0v7.8C163.7,275.9,163.4,276.2,163,276.2C163,276.2,163,276.2,163,276.2z M151.8,274.9h10.5v-6.4h-10.5 L151.8,274.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Cloud"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M336.3,260.1c-1.4-1.4-2.6-2.5-3.8-3.6c-5.3-5.4-13.3-7-20.2-4c-7,3-11.3,10.2-10.6,17.8 c0.1,1.8-0.5,2.4-2.1,2.8c-14.6,3.8-23.4,18.8-19.6,33.4c3.2,12.1,14.2,20.6,26.7,20.5c37.2,0,74.3,0,111.5,0 c1.4,0,2.8-0.1,4.3-0.3c11.9-1.8,20.8-12,20.9-24c0.1-12.3-8.6-22.9-20.5-24.7c-2.7-0.4-5.5-0.4-8.3-0.6 c4.7-24.7-11.6-42.7-28.1-47.1c-8.7-2.5-18-1.9-26.4,1.6C347.6,237.3,340,247.1,336.3,260.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M350,327.7h-43.3c-15.4,0.3-28.2-12-28.4-27.5c0-0.7,0-1.4,0-2.1c0.6-12.3,9.2-22.8,21.1-25.8 c1.4-0.4,1.7-0.7,1.6-2.1c-0.7-7.9,3.7-15.4,11-18.5c7.2-3.1,15.6-1.5,21,4.2c0.8,0.8,1.5,1.5,2.4,2.3l0.5,0.5 c4.1-13.2,12.1-22.4,23.8-27.5c17.8-7.5,38.5-1.4,49.3,14.6c6.2,9,8.4,20.2,6.4,30.9c0.6,0,1.2,0.1,1.8,0.1c1.9,0,3.9,0.2,5.8,0.4 c12.2,1.8,21.2,12.7,21.1,25.4c-0.1,12.4-9.3,22.8-21.5,24.6c-1.4,0.2-2.9,0.3-4.4,0.3L350,327.7z M319.4,251.6 c-2.4,0-4.7,0.5-6.8,1.5c-6.7,2.9-10.8,9.8-10.2,17.2c0.2,2.4-0.9,3.1-2.6,3.5c-11.4,2.8-19.5,12.8-20.1,24.5 c-0.8,14.6,10.4,27.2,25,28c0.7,0,1.3,0.1,2,0c37.2,0,74.3,0,111.5,0c1.4,0,2.8-0.1,4.2-0.3c11.6-1.7,20.2-11.6,20.3-23.3 c0.1-12-8.4-22.3-19.9-24c-1.9-0.2-3.7-0.4-5.6-0.4l-2.6-0.1c-0.2,0-0.4-0.1-0.5-0.3c-0.1-0.2-0.2-0.4-0.1-0.6 c4.6-24-10.8-41.8-27.6-46.3c-8.6-2.5-17.7-1.9-25.9,1.6c-11.8,5.1-19.5,14.1-23.4,27.7c-0.1,0.4-0.5,0.6-0.9,0.5 c-0.1,0-0.2-0.1-0.3-0.2l-1.3-1.3c-0.9-0.8-1.6-1.6-2.4-2.3C328.7,253.6,324.2,251.6,319.4,251.6L319.4,251.6z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Server_front"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210.2,120h140.4c3.7,0,6.8,3,6.8,6.8v204.1c0,3.7-3,6.8-6.8,6.8H210.2c-3.7,0-6.8-3-6.8-6.8V126.7 C203.4,123,206.5,120,210.2,120z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M350.6,338.3H210.2c-4.1,0-7.5-3.3-7.5-7.5V126.7c0-4.1,3.3-7.5,7.5-7.4h140.4c4.1,0,7.4,3.3,7.5,7.4v204.1 C358.1,335,354.7,338.3,350.6,338.3z M210.2,120.7c-3.3,0-6,2.7-6.1,6v204.2c0,3.3,2.7,6,6.1,6h140.4c3.3,0,6-2.7,6-6V126.7 c0-3.3-2.7-6-6-6L210.2,120.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 217.2,
    y: 133.5,
    width: 126.4,
    height: 31.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M343.6,165.4H217.2c-0.4,0-0.7-0.3-0.7-0.7v-31.2c0-0.4,0.3-0.7,0.7-0.7h126.4c0.4,0,0.7,0.3,0.7,0.7 c0,0,0,0,0,0v31.2C344.3,165.1,344,165.4,343.6,165.4L343.6,165.4z M217.9,164h125v-29.8h-125V164z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 233.9,
    cy: 149.1,
    r: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M332.1,145h-55c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7c0,0,0,0,0,0h55c0.4,0,0.7,0.3,0.7,0.7 C332.8,144.7,332.4,145,332.1,145z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M332.1,154.6h-55c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h55c0.4,0,0.7,0.3,0.7,0.7 C332.8,154.3,332.4,154.6,332.1,154.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M265.1,155.8h-18c-0.4,0-0.7-0.3-0.7-0.7v-11.9c0-0.4,0.3-0.7,0.7-0.7h18c0.4,0,0.7,0.3,0.7,0.7c0,0,0,0,0,0 v11.9C265.8,155.4,265.5,155.8,265.1,155.8L265.1,155.8z M247.8,154.4h16.6v-10.5h-16.6L247.8,154.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 217.2,
    y: 171.2,
    width: 126.4,
    height: 31.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M343.6,203.1H217.2c-0.4,0-0.7-0.3-0.7-0.7v-31.2c0-0.4,0.3-0.7,0.7-0.7h126.4c0.4,0,0.7,0.3,0.7,0.7 c0,0,0,0,0,0v31.2C344.3,202.8,344,203.1,343.6,203.1L343.6,203.1z M217.9,201.7h125v-29.8h-125L217.9,201.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 233.9,
    cy: 186.8,
    r: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M332.1,182.7h-55c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h55c0.4,0,0.7,0.3,0.7,0.7 C332.8,182.4,332.4,182.7,332.1,182.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M332.1,192.3h-55c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h55c0.4,0,0.7,0.3,0.7,0.7 C332.8,192,332.4,192.3,332.1,192.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M265.1,193.4h-18c-0.4,0-0.7-0.3-0.7-0.7v-11.9c0-0.4,0.3-0.7,0.7-0.7h18c0.4,0,0.7,0.3,0.7,0.7c0,0,0,0,0,0 v11.9C265.8,193.1,265.5,193.4,265.1,193.4L265.1,193.4z M247.8,192h16.6v-10.4h-16.6V192z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 217.2,
    y: 208.9,
    width: 126.4,
    height: 31.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M343.6,240.8H217.2c-0.4,0-0.7-0.3-0.7-0.7v-31.2c0-0.4,0.3-0.7,0.7-0.7h126.4c0.4,0,0.7,0.3,0.7,0.7 c0,0,0,0,0,0v31.2C344.3,240.5,344,240.8,343.6,240.8L343.6,240.8z M217.9,239.4h125v-29.8h-125L217.9,239.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 233.9,
    cy: 224.5,
    r: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M332.1,220.4h-55c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h55c0.4,0,0.7,0.3,0.7,0.7 C332.8,220,332.4,220.3,332.1,220.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M332.1,230h-55c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h55c0.4,0,0.7,0.3,0.7,0.7 C332.8,229.7,332.4,230,332.1,230z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M265.1,231.1h-18c-0.4,0-0.7-0.3-0.7-0.7v-11.9c0-0.4,0.3-0.7,0.7-0.7h18c0.4,0,0.7,0.3,0.7,0.7c0,0,0,0,0,0 v11.9C265.8,230.8,265.5,231.1,265.1,231.1L265.1,231.1z M247.8,229.7h16.6v-10.5h-16.6L247.8,229.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 217.2,
    y: 246.5,
    width: 126.4,
    height: 31.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M343.6,278.4H217.2c-0.4,0-0.7-0.3-0.7-0.7l0,0v-31.2c0-0.4,0.3-0.7,0.7-0.7h126.4c0.4,0,0.7,0.3,0.7,0.7 c0,0,0,0,0,0v31.2C344.3,278.1,344,278.4,343.6,278.4L343.6,278.4z M217.9,277h125v-29.8h-125V277z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 233.9,
    cy: 262.1,
    r: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M332.1,258h-55c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7c0,0,0,0,0,0h55c0.4,0,0.7,0.3,0.7,0.7 C332.8,257.7,332.4,258,332.1,258z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M332.1,267.7h-55c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7c0,0,0,0,0,0h55c0.4,0,0.7,0.3,0.7,0.7 S332.5,267.7,332.1,267.7C332.1,267.7,332.1,267.7,332.1,267.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M265.1,268.8h-18c-0.4,0-0.7-0.3-0.7-0.7l0,0v-11.8c0-0.4,0.3-0.7,0.7-0.7h18c0.4,0,0.7,0.3,0.7,0.7l0,0v11.9 C265.8,268.5,265.5,268.8,265.1,268.8z M247.8,267.4h16.6v-10.4h-16.6L247.8,267.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 217.2,
    y: 284.2,
    width: 126.4,
    height: 31.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M343.6,316.1H217.2c-0.4,0-0.7-0.3-0.7-0.7l0,0v-31.2c0-0.4,0.3-0.7,0.7-0.7c0,0,0,0,0,0h126.4 c0.4,0,0.7,0.3,0.7,0.7v0v31.2C344.3,315.8,344,316.1,343.6,316.1z M217.9,314.7h125v-29.8h-125L217.9,314.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 233.9,
    cy: 299.8,
    r: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M332.1,295.7h-55c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7c0,0,0,0,0,0h55c0.4,0,0.7,0.3,0.7,0.7 C332.8,295.4,332.4,295.7,332.1,295.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M332.1,305.4h-55c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7c0,0,0,0,0,0h55c0.4,0,0.7,0.3,0.7,0.7 C332.8,305,332.4,305.3,332.1,305.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M265.1,306.5h-18c-0.4,0-0.7-0.3-0.7-0.7l0,0v-11.9c0-0.4,0.3-0.7,0.7-0.7h18c0.4,0,0.7,0.3,0.7,0.7v0v11.9 C265.8,306.1,265.5,306.5,265.1,306.5L265.1,306.5z M247.8,305.1h16.6v-10.5h-16.6L247.8,305.1z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Upload"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.8,276.5c-1.7-1.7-3.2-3-4.5-4.3c-6.3-6.6-16.1-8.5-24.4-4.9c-8.5,3.7-13.6,12.4-12.8,21.5 c0.2,2.2-0.5,2.9-2.6,3.4c-14.1,3.6-24.2,15.9-24.9,30.4c-0.7,19.5,13.9,34.8,33.5,34.8c44.9,0,89.8,0,134.7,0 c1.7,0,3.5-0.1,5.2-0.4c14.4-2.2,25.1-14.4,25.3-29c0.2-14.8-10.4-27.7-24.8-29.8c-3.3-0.5-6.7-0.5-10-0.7c5.7-29.8-14-51.6-34-57 c-10.9-2.9-21.5-2.5-31.9,2C139.4,249,130.4,260.8,125.8,276.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M143.3,358.1H90.1c-18.6,0.3-33.9-14.5-34.2-33c0-0.8,0-1.7,0-2.5c0.7-14.8,11-27.4,25.4-31 c1.8-0.5,2.2-0.9,2-2.7c-0.8-9.5,4.5-18.4,13.2-22.2c8.6-3.8,18.7-1.8,25.2,5c0.9,0.9,1.9,1.8,2.9,2.8l0.8,0.7 c4.9-16,14.6-27.2,28.8-33.3c21.4-9.1,46.3-1.7,59.4,17.6c5.2,7.6,10.7,20.2,7.6,37.4l2.4,0.1c2.3,0,4.7,0.2,7,0.5 c14.6,2.2,25.5,15.3,25.4,30.5c-0.2,14.9-11.2,27.5-25.9,29.6c-1.7,0.2-3.5,0.4-5.2,0.4L143.3,358.1z M105.5,266.1 c-2.9,0-5.7,0.6-8.3,1.8c-8.2,3.6-13.2,12-12.4,20.9c0.2,2.8-1,3.6-3.1,4.1c-13.8,3.4-23.7,15.5-24.4,29.7c-1,17.8,12.6,33,30.3,34 c0.8,0,1.6,0.1,2.4,0c44.9,0,89.8,0,134.7,0c1.7,0,3.4-0.1,5.1-0.4c14.1-2.1,24.5-14.1,24.7-28.3c0.2-14.5-10.2-27-24.2-29.1 c-2.3-0.3-4.5-0.5-6.8-0.5c-1.1,0-2.1-0.1-3.2-0.1c-0.4,0-0.7-0.4-0.7-0.8c0,0,0,0,0-0.1c5.6-29.1-13.1-50.7-33.5-56.1 c-10.4-3-21.5-2.3-31.4,1.9c-14.3,6.1-23.6,17.1-28.3,33.5c-0.1,0.4-0.5,0.6-0.9,0.5c-0.1,0-0.2-0.1-0.3-0.2l-1.6-1.5 c-1.1-1-2-1.9-2.9-2.8C116.8,268.5,111.3,266.2,105.5,266.1L105.5,266.1z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "166,364.9 166,317.9 174.4,317.9 158,299.9 141.6,317.9 150,317.9 150,364.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M166,365.6c-0.4,0-0.7-0.3-0.7-0.7l0,0v-47c0-0.4,0.3-0.7,0.7-0.7c0,0,0,0,0,0h6.8L158,300.9l-14.8,16.3h6.8 c0.4,0,0.7,0.3,0.7,0.7l0,0v47c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7c0,0,0,0,0,0v-46.3h-7.7c-0.3,0-0.5-0.2-0.6-0.4 c-0.1-0.3-0.1-0.5,0.1-0.8l16.4-18c0.3-0.3,0.7-0.3,1,0l16.4,18c0.2,0.2,0.2,0.5,0.1,0.8c-0.1,0.3-0.4,0.4-0.6,0.4h-7.7v46.3 C166.7,365.2,166.4,365.5,166,365.6z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Download"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M306.2,264.3c-9.2-3.9-19.5-4.6-29.1-1.8c-18.2,4.9-36.3,24.8-31.1,52.1c-3.1,0.2-6.2,0.2-9.2,0.6 c-13.1,2-22.8,13.7-22.6,27.3c0.2,13.3,10,24.5,23.1,26.5c1.6,0.2,3.1,0.3,4.7,0.3c41,0,82.1,0,123.1,0c17.8,0,31.3-14,30.6-31.8 c-0.7-13.2-9.9-24.5-22.7-27.8c-1.9-0.5-2.5-1.1-2.3-3.1c0.7-8.4-4-16.3-11.7-19.7c-7.6-3.3-16.6-1.5-22.3,4.5 c-1.3,1.2-2.6,2.5-4.1,4C328.3,281,320,270.2,306.2,264.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M316.9,370H242c-1.6,0-3.2-0.1-4.8-0.4c-13.5-2-23.6-13.5-23.7-27.2c-0.1-13.9,9.8-26,23.2-28 c2.1-0.3,4.2-0.4,6.4-0.5l2.1-0.1c-2.8-15.7,2.2-27.2,7-34.2c11.9-17.7,34.7-24.4,54.3-16.1c13,5.6,21.8,15.8,26.3,30.4l0.6-0.6 c1-0.9,1.8-1.7,2.6-2.6c6-6.2,15.2-8,23.1-4.6c8,3.5,12.9,11.7,12.1,20.4c-0.1,1.6,0.2,2,1.8,2.4c13.2,3.3,22.6,14.8,23.3,28.4 c1,17-12,31.5-29,32.5c-0.8,0-1.5,0.1-2.3,0H316.9z M289.4,261.5c-4.1,0-8.2,0.6-12.1,1.7c-18.6,5-35.7,24.6-30.6,51.2 c0,0.2,0,0.4-0.1,0.6c-0.1,0.2-0.3,0.3-0.5,0.3c-1,0.1-1.9,0.1-2.9,0.1c-2.1,0.1-4.1,0.2-6.2,0.5c-12.7,1.9-22.2,13.3-22.1,26.6 c0.1,13,9.7,23.9,22.5,25.8c1.5,0.2,3.1,0.3,4.6,0.3c41,0,82.1,0,123.1,0c16.2,0.3,29.6-12.6,29.9-28.9c0-0.7,0-1.5,0-2.2 c-0.6-13-9.6-24-22.2-27.1c-2-0.5-3-1.3-2.9-3.8c0.7-8.1-3.8-15.8-11.3-19c-7.4-3.2-16-1.5-21.6,4.3c-0.9,0.9-1.7,1.7-2.7,2.6 l-1.5,1.4c-0.2,0.2-0.4,0.2-0.7,0.2c-0.2-0.1-0.4-0.3-0.5-0.5c-4.3-15-12.8-25-25.8-30.6l0,0C300.7,262.7,295.1,261.5,289.4,261.5z "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "297.2,315 297.2,362 288.9,362 305.2,380 321.6,362 313.2,362 313.2,315  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M305.2,380.7c-0.2,0-0.4-0.1-0.5-0.2l-16.4-18c-0.3-0.3-0.2-0.7,0-1c0.1-0.1,0.3-0.2,0.5-0.2h7.7V315 c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7v47c0,0.4-0.3,0.7-0.7,0.7h0h-6.8l14.8,16.3l14.8-16.3h-6.8c-0.4,0-0.7-0.3-0.7-0.7v0 v-47c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7v46.3h7.7c0.4,0,0.7,0.3,0.7,0.7c0,0.2-0.1,0.3-0.2,0.5l-16.4,18 C305.6,380.6,305.4,380.7,305.2,380.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataCenter);
export default __webpack_public_path__ + "static/media/Data-Center.ed6e3e5540b9e3b73c4dd5a0c54243a0.svg";
export { ForwardRef as ReactComponent };